export interface IRalGroup {
    color: string;
    items: IRalColor[];
}

export interface IRalColor {
    ral: number;
    color: string;
}

export let RalGroups: IRalGroup[] = [
    {
        color: "#d7b327",
        items: [
            { ral: 1000, color: "#cdba88" },
            { ral: 1001, color: "#d0b084" },
            { ral: 1002, color: "#d2aa6d" },
            { ral: 1003, color: "#f9a800" },
            { ral: 1004, color: "#e49e00" },
            { ral: 1005, color: "#cb8e00" },
            { ral: 1006, color: "#e29000" },
            { ral: 1007, color: "#e88c00" },
            { ral: 1011, color: "#af804f" },
            { ral: 1012, color: "#ddaf27" },
            { ral: 1013, color: "#e3d9c6" },
            { ral: 1014, color: "#ddc49a" },
            { ral: 1015, color: "#e6d2b5" },
            { ral: 1016, color: "#f1dd38" },
            { ral: 1017, color: "#f6a950" },
            { ral: 1018, color: "#faca30" },
            { ral: 1019, color: "#a48f7a" },
            { ral: 1020, color: "#a08f65" },
            { ral: 1021, color: "#f6b600" },
            { ral: 1023, color: "#f7b500" },
            { ral: 1024, color: "#ba8f4c" },
            { ral: 1026, color: "#ffff00" },
            { ral: 1027, color: "#a77f0e" },
            { ral: 1028, color: "#ff9b00" },
            { ral: 1032, color: "#e2a300" },
            { ral: 1033, color: "#f99a1c" },
            { ral: 1034, color: "#eb9c52" },
            { ral: 1035, color: "#908370" },
            { ral: 1036, color: "#80643f" },
            { ral: 1037, color: "#f09200" },
        ]
    },
    {
        color: "#ff7700",
        items: [
            { ral: 2000, color: "#da6e00" },
            { ral: 2001, color: "#ba481b" },
            { ral: 2002, color: "#bf3922" },
            { ral: 2003, color: "#f67828" },
            { ral: 2004, color: "#e25303" },
            { ral: 2005, color: "#ff4d06" },
            { ral: 2007, color: "#ffb200" },
            { ral: 2008, color: "#ed6b21" },
            { ral: 2009, color: "#de5307" },
            { ral: 2010, color: "#d05d28" },
            { ral: 2011, color: "#e26e0e" },
            { ral: 2012, color: "#d5654d" },
            { ral: 2013, color: "#923e25" },
        ],
    },
    {
        color: "#d64818",
        items: [
            { ral: 3000, color: "#a72920" },
            { ral: 3001, color: "#9b2423" },
            { ral: 3002, color: "#9b2321" },
            { ral: 3003, color: "#861a22" },
            { ral: 3004, color: "#6b1c23" },
            { ral: 3005, color: "#59191f" },
            { ral: 3007, color: "#3e2022" },
            { ral: 3009, color: "#6d342d" },
            { ral: 3011, color: "#792423" },
            { ral: 3012, color: "#c6846d" },
            { ral: 3013, color: "#972e25" },
            { ral: 3014, color: "#cb7375" },
            { ral: 3015, color: "#d8a0a6" },
            { ral: 3016, color: "#a63d2f" },
            { ral: 3017, color: "#cb555d" },
            { ral: 3018, color: "#c73f4a" },
            { ral: 3020, color: "#bb1e10" },
            { ral: 3022, color: "#cf6955" },
            { ral: 3024, color: "#ff2d21" },
            { ral: 3026, color: "#ff2a1b" },
            { ral: 3027, color: "#ab273c" },
            { ral: 3028, color: "#cc2c24" },
            { ral: 3031, color: "#a63437" },
            { ral: 3032, color: "#701d23" },
            { ral: 3033, color: "#a53a2d" },
        ],
    },
    {
        color: "#8b1892",
        items: [
            { ral: 4001, color: "#816183" },
            { ral: 4002, color: "#8d3c4b" },
            { ral: 4003, color: "#c4618c" },
            { ral: 4004, color: "#651e38" },
            { ral: 4005, color: "#76689a" },
            { ral: 4006, color: "#903373" },
            { ral: 4007, color: "#47243c" },
            { ral: 4008, color: "#844c82" },
            { ral: 4009, color: "#9d8692" },
            { ral: 4010, color: "#bc4077" },
            { ral: 4011, color: "#6e6387" },
            { ral: 4012, color: "#6b6b7f" },
        ],
    },
    {
        color: "#0d2791",
        items: [
            { ral: 5000, color: "#314f6f" },
            { ral: 5001, color: "#0f4c64" },
            { ral: 5002, color: "#00387b" },
            { ral: 5003, color: "#1f3855" },
            { ral: 5004, color: "#191e28" },
            { ral: 5005, color: "#005387" },
            { ral: 5007, color: "#376b8c" },
            { ral: 5008, color: "#2b3a44" },
            { ral: 5009, color: "#225f78" },
            { ral: 5010, color: "#004f7c" },
            { ral: 5011, color: "#1a2b3c" },
            { ral: 5012, color: "#0089b6" },
            { ral: 5013, color: "#193153" },
            { ral: 5014, color: "#637d96" },
            { ral: 5015, color: "#007cb0" },
            { ral: 5017, color: "#005b8c" },
            { ral: 5018, color: "#058b8c" },
            { ral: 5019, color: "#005e83" },
            { ral: 5020, color: "#00414b" },
            { ral: 5021, color: "#007577" },
            { ral: 5022, color: "#222d5a" },
            { ral: 5023, color: "#42698c" },
            { ral: 5024, color: "#6093ac" },
            { ral: 5025, color: "#21697c" },
            { ral: 5026, color: "#0f3052" },
        ],
    },
    {
        color: "#1e7f16",
        items: [
            { ral: 6000, color: "#3c7460" },
            { ral: 6001, color: "#366735" },
            { ral: 6002, color: "#325928" },
            { ral: 6003, color: "#50533c" },
            { ral: 6004, color: "#024442" },
            { ral: 6005, color: "#114232" },
            { ral: 6006, color: "#3c392e" },
            { ral: 6007, color: "#2c3222" },
            { ral: 6008, color: "#37342a" },
            { ral: 6009, color: "#27352a" },
            { ral: 6010, color: "#4d6f39" },
            { ral: 6011, color: "#6c7c59" },
            { ral: 6012, color: "#303d3a" },
            { ral: 6013, color: "#7d765a" },
            { ral: 6014, color: "#474135" },
            { ral: 6015, color: "#3d3d36" },
            { ral: 6016, color: "#00694c" },
            { ral: 6017, color: "#587f40" },
            { ral: 6018, color: "#61993b" },
            { ral: 6019, color: "#b9ceac" },
            { ral: 6020, color: "#37422f" },
            { ral: 6021, color: "#8a9977" },
            { ral: 6022, color: "#3a3327" },
            { ral: 6024, color: "#008351" },
            { ral: 6025, color: "#5e6e3b" },
            { ral: 6026, color: "#005f4e" },
            { ral: 6027, color: "#7ebab5" },
            { ral: 6028, color: "#315442" },
            { ral: 6029, color: "#006f3d" },
            { ral: 6032, color: "#237f52" },
            { ral: 6033, color: "#46877f" },
            { ral: 6034, color: "#7aacac" },
            { ral: 6035, color: "#194d25" },
            { ral: 6036, color: "#04574b" },
            { ral: 6037, color: "#008b29" },
            { ral: 6038, color: "#00b51a" },
        ],
    },
    {
        color: "#888888",
        items: [
            { ral: 7000, color: "#7a888e" },
            { ral: 7001, color: "#8c969d" },
            { ral: 7002, color: "#817863" },
            { ral: 7003, color: "#7a7669" },
            { ral: 7004, color: "#9b9b9b" },
            { ral: 7005, color: "#6c6e6b" },
            { ral: 7006, color: "#766a5e" },
            { ral: 7008, color: "#745e3d" },
            { ral: 7009, color: "#5d6058" },
            { ral: 7010, color: "#585c56" },
            { ral: 7011, color: "#52595d" },
            { ral: 7012, color: "#575d5e" },
            { ral: 7013, color: "#575044" },
            { ral: 7015, color: "#4f5358" },
            { ral: 7016, color: "#383e42" },
            { ral: 7021, color: "#2f3234" },
            { ral: 7022, color: "#4c4a44" },
            { ral: 7023, color: "#808076" },
            { ral: 7024, color: "#45494e" },
            { ral: 7026, color: "#374345" },
            { ral: 7030, color: "#928e85" },
            { ral: 7031, color: "#5b686d" },
            { ral: 7032, color: "#b5b0a1" },
            { ral: 7033, color: "#7f8274" },
            { ral: 7034, color: "#92886f" },
            { ral: 7035, color: "#c5c7c4" },
            { ral: 7036, color: "#979392" },
            { ral: 7037, color: "#7a7b7a" },
            { ral: 7038, color: "#b0b0a9" },
            { ral: 7039, color: "#6b665e" },
            { ral: 7040, color: "#989ea1" },
            { ral: 7042, color: "#8e9291" },
            { ral: 7043, color: "#4f5250" },
            { ral: 7044, color: "#b7b3a8" },
            { ral: 7045, color: "#8d9295" },
            { ral: 7046, color: "#7f868a" },
            { ral: 7047, color: "#c8c8c7" },
            { ral: 7048, color: "#817b73" },
        ],
    },
    {
        color: "#6c4a11",
        items: [
            { ral: 8000, color: "#89693e" },
            { ral: 8001, color: "#9d622b" },
            { ral: 8002, color: "#794d3e" },
            { ral: 8003, color: "#7e4b26" },
            { ral: 8004, color: "#8d4931" },
            { ral: 8007, color: "#70452a" },
            { ral: 8008, color: "#724a25" },
            { ral: 8011, color: "#5a3826" },
            { ral: 8012, color: "#66332b" },
            { ral: 8014, color: "#4a3526" },
            { ral: 8015, color: "#5e2f26" },
            { ral: 8016, color: "#4c2b20" },
            { ral: 8017, color: "#442f29" },
            { ral: 8019, color: "#3d3635" },
            { ral: 8022, color: "#1a1718" },
            { ral: 8023, color: "#a45729" },
            { ral: 8024, color: "#795038" },
            { ral: 8025, color: "#755847" },
            { ral: 8028, color: "#513a2a" },
            { ral: 8029, color: "#7f4031" },
        ],
    },
    {
        color: "#000",
        items: [
            { ral: 9001, color: "#e9e0d2" },
            { ral: 9002, color: "#d7d5cb" },
            { ral: 9003, color: "#ecece7" },
            { ral: 9004, color: "#2b2b2c" },
            { ral: 9005, color: "#0e0e10" },
            { ral: 9006, color: "#a1a1a0" },
            { ral: 9007, color: "#878581" },
            { ral: 9010, color: "#f1ece1" },
            { ral: 9011, color: "#27292b" },
            { ral: 9016, color: "#f1f0ea" },
            { ral: 9017, color: "#2a292a" },
            { ral: 9018, color: "#c8cbc4" },
            { ral: 9022, color: "#858583" },
            { ral: 9023, color: "#797b7a" },
        ],
    }
];

export let RalMap: { [ral: number]: string } = {};
RalGroups.forEach((group: IRalGroup) => {
    group.items.forEach((color: IRalColor) => RalMap[color.ral] = color.color);
});



// WEBPACK FOOTER //
// ./src/app/shared/ral-colorpicker/ral-colors.ts